<template>
  <div class="app-shell">
    <SiteNavigation />
    <main class="app-route-stage">
      <RouterView />
    </main>
  </div>
</template>

<script setup>
import { onBeforeUnmount, watch } from "vue";
import { useRoute } from "vue-router";
import SiteNavigation from "@/components/SiteNavigation.vue";

const route = useRoute();
const randomColors = ["#0F0", "#F00", "#00F", "#0FF", "#F0F", "#FF0"];

function applyRandomBackground() {
  const color = randomColors[Math.floor(Math.random() * randomColors.length)];
  document.documentElement.style.setProperty("--app-random-bg", color);
  document.body.style.backgroundColor = color;
}

watch(
  () => route.fullPath,
  () => {
    applyRandomBackground();
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  document.documentElement.style.removeProperty("--app-random-bg");
  document.body.style.backgroundColor = "#000";
});
</script>

<style>
@font-face {
  font-family: "Comic Sans";
  src: url("./components/easteregg/fonts/LDFComicSans.ttf") format("truetype");
}

@font-face {
  font-family: "Smiley Sans";
  src: url("./components/easteregg/fonts/SmileySans-Oblique.ttf") format("truetype");
}

:root {
  --site-font-stack: "Comic Sans", "Smiley Sans", Arial, sans-serif;
}

html,
body,
#app {
  min-height: 100%;
  margin: 0;
}

body {
  overflow-x: hidden;
  background: #000;
  color: #fff;
  font-family: var(--site-font-stack);
}

* {
  box-sizing: border-box;
}

button,
input,
textarea,
select {
  font: inherit;
}

a {
  color: inherit;
  text-decoration: none;
}

.app-shell {
  min-height: 100vh;
  background: var(--app-random-bg, #000);
  font-family: var(--site-font-stack);
  transition: background-color 0.25s ease;
}

.app-route-stage {
  padding-bottom: 40px;
}
</style>
